import styled from "styled-components";

export const ClientSettingsTitleDefaultBox = styled.p`
    ${({ theme }) => theme.font.presets.regular};

    color: ${({ theme }) => theme.colors.textContrast};
    font-size: 14px;
    font-weight: 700;
    margin: 0 auto;
`